export { ProductFormDS, default } from './product-form-ds'
